import comp from "./LockedScreenWrapper";
export default comp;
